import { useContext, useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useDealerAdmin } from '../../contexts/DealerAdminContext';
import TenantContext from '../../libs/contexts/TenantContext';
import {
  readSupportedTenantSession,
  subscribeSupportedTenantSession,
} from './supportedTenantsSession';

export const ALGO_DEVICE_SUPPORT_LABEL = 'Enable Algo device support';
export const ALGO_DEVICE_SUPPORT_HELP = 'Allows this user to access Algo Agents and Algo Devices for this tenant.';

let epoch = 0;

export function currentAlgoAccessEpoch() {
  return epoch;
}

export function resetAlgoAccess() {
  epoch += 1;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('sb-algo-access-reset'));
  }
}

export function isStaleAlgoAccess(started) {
  return started !== epoch;
}

export function canAssignAlgoDeviceSupport({ role, dealerActive = false } = {}) {
  if (dealerActive) return true;
  const normalized = String(role || '');
  return normalized === 'superadmin' || normalized === 'admin';
}

export function algoNavEnabled({
  role,
  dealerActive = false,
  dealerFlag = false,
  supportTenantId = '',
  supportFlag = false,
  membershipFlag = false,
} = {}) {
  if (role === 'superadmin') return true;
  if (dealerActive) return dealerFlag === true;
  if (supportTenantId) return supportFlag === true;
  return membershipFlag === true;
}

export function useAlgoDeviceSupport() {
  const auth = useAuth() || {};
  const dealer = useDealerAdmin() || {};
  const tenant = useContext(TenantContext);
  const [supportSession, setSupportSession] = useState(() => readSupportedTenantSession());
  useEffect(() => subscribeSupportedTenantSession(() => setSupportSession(readSupportedTenantSession())), []);
  const role = auth.role || auth.userData?.role || auth.userClaims?.role;
  const selectedId = tenant?.selectedTenant?.id;
  const membership = selectedId ? tenant?.membershipsByTenantId?.[selectedId] : null;
  return algoNavEnabled({
    role,
    dealerActive: Boolean(dealer.active),
    dealerFlag: dealer.algoDeviceSupport,
    supportTenantId: dealer.active ? '' : (supportSession?.tenantId || ''),
    supportFlag: supportSession?.tenantAlgoEnabled === true,
    membershipFlag: membership?.algoDeviceSupport,
  });
}
